"use strict";

import $ from 'jquery';

function updateFloatingLabel($input) {
    let $formGroup = $input.closest('.form-group');
    let val = $input.val();
    let placeholder = $input.attr('placeholder');

    if ((val !== null && val.length > 0) || (placeholder !== undefined && placeholder.length > 0)) {
        $input.addClass('has-value');
        $formGroup.addClass('has-value');
    } else {
        $input.removeClass('has-value');
        $formGroup.removeClass('has-value');
    }
}

export function initInScope($scope) {
    console.log("init in scope");

    $scope.find('.js-floating-label').each(function () {
        updateFloatingLabel($(this));
    });

    const events = "propertychange.floatingLabel change.floatingLabel keyup.floatingLabel input.floatingLabel paste.floatingLabel";

    $scope.off(events, '.js-floating-label');

    $scope.on(events, '.js-floating-label', function () {
        updateFloatingLabel($(this));
    });
}